
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.25 8.72A4.92 4.92 0 0012.95 5a5 5 0 00-10 0A4.92 4.92 0 004.7 8.72 8 8 0 000 16a1 1 0 102 0 6 6 0 1112 0 1 1 0 002 0 8 8 0 00-4.75-7.28zM7.95 8a3 3 0 110-6 3 3 0 010 6zm8.5-5a1 1 0 00-1 1v2a1 1 0 002 0V4a1 1 0 00-1-1zm-.75 5.29a1.05 1.05 0 00-.29.71 1 1 0 00.29.71c.097.088.209.16.33.21a.94.94 0 00.76 0 .9.9 0 00.54-.54.84.84 0 00.08-.38 1 1 0 00-1.71-.71z"}})])
          )
        }
      }
    